export default __webpack_public_path__ + "static/media/group_750_350.1cec215d.png";